import { IResourceComponentsProps } from "@refinedev/core";
import { AntdCreateInferencer } from "@refinedev/inferencer/antd";
import Cw8Create from "components/cw8/Cw8Create";

export const InfografiasCreate: React.FC<IResourceComponentsProps> = () => {
  // return <AntdCreateInferencer />;
  const resourceName :string = 'infografia';
  return (
    <Cw8Create
      resourceName = {resourceName}
    ></Cw8Create>
  );
};
